// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";


export const tipoGarantiasFullfilledReducer = makeSetReducer(['tipo_garantias/fullfilled']);
